import React from 'react';
import { Flame } from 'lucide-react';
import styles from './CupSleeveHero.module.css';

const CupSleeveHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
}) => {
  const title = mainTitleLines.join(' ');
  const bannerImage = imageSecondary ?? imagePrimary;
  const accentImage = imagePrimary;

  return (
    <section className={styles.heroSection}>
      {bannerImage && (
        <img
          className={styles.bgImage}
          src={bannerImage.src}
          alt=""
          aria-hidden="true"
          loading="eager"
        />
      )}
      <div className={styles.overlay} aria-hidden="true" />

      <div className={styles.inner}>
        <div className={styles.layout}>
          <div className={styles.contentCard}>
            <span className={styles.badge}>{badge}</span>

            <div className={styles.titleBlock}>
              <span className={styles.eyebrow}>{scriptTitle}</span>
              <h1 className={styles.title}>{title}</h1>
            </div>

            {kicker && <p className={styles.kicker}>{kicker}</p>}

            {descriptions[0] && <p className={styles.lead}>{descriptions[0]}</p>}

            {descriptions[1] && (
              <p className={styles.support}>{descriptions[1]}</p>
            )}

            {features?.length > 0 && (
              <ul className={styles.featureRow}>
                {features.map((feature, index) => (
                  <li key={index} className={styles.featureChip}>
                    <Flame size={12} aria-hidden="true" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {accentImage && (
            <div className={styles.accentPanel}>
              <figure className={styles.accentFrame}>
                <img src={accentImage.src} alt={accentImage.alt} />
              </figure>
              <span className={styles.cornerAccent} aria-hidden="true" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CupSleeveHero;
